<template>
  <button
    :class="`a-button-secondary ${buttonSecondary.class}`"
    :data-tooltip-text="buttonSecondary.tooltip"
    :type="buttonSecondary.type"
    @click="click($event)"
  >
    <i
      v-if="buttonSecondary.icon.length && !showLoading"
      :class="buttonSecondary.text.length
        ? `${buttonSecondary.icon} margin-right-xsmall`
        : buttonSecondary.icon"
    >
    </i>
    <i
      v-else-if="buttonSecondary.icon.length && showLoading"
      :class="buttonSecondary.text.length
        ? 'fas fa-spinner fa-spin margin-right-xsmall'
        : 'fas fa-spinner fa-spin'"
    >
    </i>
    <span v-show="buttonSecondary.text.length">{{ buttonSecondary.text }}</span>
  </button>
</template>

<script>
export default {
  name: 'AtomButtonSecondary',

  props: {
    buttonSecondary: Object,
    element: [Array, Number, String, Object],

    showLoading: {
      type: Boolean,
      default: false
    }
  },

  created () {
    this.buttonSecondary.icon = this.buttonSecondary.type === 'reset'
      ? 'far fa-times'
      : this.buttonSecondary.icon
  },

  methods: {
    click (event) {
      if (this.buttonSecondary.component.length) {
        event.stopPropagation()
        this.$emit(this.buttonSecondary.method, this.buttonSecondary.component, this.element)
      } else {
        this.$emit(this.buttonSecondary.method, this.element)
      }
    }
  }
}
</script>
